var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentcolor",
    width: "800px",
    height: "800px",
    viewBox: "0 0 35 35",
    "data-name": "Layer 2",
    id: "e37b3a33-67a4-43e9-ab68-4fc9ee55441c",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.739,26.47a13.11,13.11,0,1,1,13.11-13.11A13.124,13.124,0,0,1,13.739,26.47Zm0-23.72a10.61,10.61,0,1,0,10.61,10.61A10.622,10.622,0,0,0,13.739,2.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.121,34.75a1.246,1.246,0,0,1-.884-.366L20.858,23.005a1.25,1.25,0,0,1,1.768-1.768L34.005,32.616a1.25,1.25,0,0,1-.884,2.134Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.621b122b09e2ad217bc1656e7a512daa.svg";
export { ForwardRef as ReactComponent };